import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const InsuranceAdminToken = localStorage.getItem("InsuranceAdminToken");

// Create an instance of axios
const api = axios.create({
  //Prdouction
  // baseURL: "https://www.suregrowthsolution.com/",

  //Development
  baseURL: "https://dev.suregrowthsolution.com/",
  // baseURL: "http://localhost:5001/",
  // baseURL: "http://192.168.1.7:5001",
  // baseURL :"http://192.168.1.29:5001",
  // baseURL:"http://10.109.80.1:5001",
  // baseURL: "http://10.161.110.1:5001/",
  // baseURL:"http://10.145.197.113:5001/",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${InsuranceAdminToken}`,
  },
});

// Enhanced response interceptor with comprehensive error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;

      // Handle authentication failures
      if ([401, 403].includes(status)) {
        toast.error("Session expired. Please login again.");
        handleLogout();
        return Promise.reject(error);
      }

      // Handle other HTTP errors
      const errorMessages = {
        400: "Invalid request data",
        404: "Resource not found",
        422: "Validation failed",
        500: "Server error occurred",
      };

      const message = errorMessages[status] || "Request failed";
      toast.error(message);

    } else if (error.request) {
      toast.error("Network error. Please check your connection.");
    } else {
      toast.error("An unexpected error occurred.");
    }

    return Promise.reject(error);
  }
);

// Function to handle logout
export const handleLogout = () => {
  // Clear all storage
  localStorage.clear();
  sessionStorage.clear();

  // Redirect to authentication
  window.location.href = "/";
};

// Function to check if token is expired
export const isTokenExpired = () => {
  const token = localStorage.getItem("InsuranceAdminToken");
  if (!token) return true;

  try {
    // Decode JWT payload and check expiration
    const [, payloadBase64] = token.split('.');
    const payload = JSON.parse(atob(payloadBase64));

    // Add 5-minute buffer for proactive refresh
    const expirationBuffer = 300; // 5 minutes in seconds
    const currentTime = Math.floor(Date.now() / 1000);

    return payload.exp < currentTime + expirationBuffer;
  } catch (error) {
    console.warn("Token validation failed:", error.message);
    return true; // Fail secure - treat invalid tokens as expired
  }
};

// Function to validate token and logout if expired
export const validateTokenAndLogout = () => {
  if (isTokenExpired()) {
    toast.error("Session expired. Please login again.");
    handleLogout();
    return false;
  }
  return true;
};

// Function to handle GET requests
export const getData = async (endpoint) => {
  try {
    // Check if token exists before making request
    const token = localStorage.getItem("InsuranceAdminToken");
    if (!token) {
      throw new Error("No token found");
    }

    const response = await api.get(endpoint);
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const ImageBaseUrl = "http://103.174.103.151/farm_fusion_api/";

// Function to handle POST requests
export const postData = async (endpoint, data) => {
  try {
    const response = await api.post(endpoint, data);
    return response.data;
  } catch (error) {
    console.error("Error posting data:", error);
    throw error;
  }
};

export const DeleteData = async (endpoint, data) => {
  try {
    const response = await api.delete(endpoint, { data });
    return response.data;
  } catch (error) {
    console.error("Error posting data:", error);
    throw error;
  }
};

export const postFormData = async (endpoint, data) => {
  try {
    const response = await api.post(endpoint, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error posting data:", error);
    throw error;
  }
};

// Function to handle PUT requests
export const putData = async (endpoint, data) => {
  try {
    const response = await api.put(endpoint, data);
    return response.data;
  } catch (error) {
    console.error("Error updating data:", error);
    throw error;
  }
};

export const putFormData = async (endpoint, data) => {
  try {
    const response = await api.put(endpoint, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating data:", error);
    throw error;
  }
};

// Function to handle DELETE requests
export const deleteData = async (endpoint, data) => {
  try {
    const response = await api.delete(endpoint, { data });
    return response.data;
  } catch (error) {
    console.error("Error deleting data:", error);
    throw error;
  }
};

// Function to handle image file uploads
export const ImageFileUpload = async (ImageUrl, data) => {
  try {
    const response = await api.post(ImageUrl, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error posting data:", error);
    throw error;
  }
};
